import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, UploadResponse } from '@/types';
import type { DocumentType } from '@/types';

export const uploadApi = {
  async uploadDocument(
    file: File,
    type: DocumentType,
    onProgress?: (percent: number) => void
  ): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    const response = await apiClient.post<ApiResponse<UploadResponse>>(
      '/upload/document',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total && onProgress) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percent);
          }
        },
      }
    );

    return response.data.data!;
  },

  async deleteDocument(documentId: string): Promise<void> {
    await apiClient.delete(`/upload/document/${documentId}`);
  },
};

/** @deprecated Use uploadApi from '@/features/onboarding/api/upload.api' */
export const uploadService = uploadApi;
